import React from "react";
import { useNavigate } from "react-router-dom";

import { AiOutlineDownload } from "react-icons/ai";

const Card = ({ data,getAdmitCardsOfAStudent }) => {
  const navigate = useNavigate();


  const handleCardClick = () => {
    // Redirect to a dummy route
    //navigate(`/gradeentryform/${data.data}/${session}/${courseCode}`); 
  };

  return (
    <div
      onClick={handleCardClick}
      className={`w-[160px] h-[150px] shadow-lg rounded-2xl p-4 flex flex-col justify-center cursor-pointer hover:shadow-xl transition-shadow duration-300
        bg-gradient-to-r from-blue-300 to-blue-600 hover:from-blue-500 hover:to-blue-700 text-white`
      }
    >
        <p className="w-full text-center text-xs text-white">SEMESTER</p>
      <p className="w-full text-xl text-center mb-[10px]">{data.semester}</p>      
      

      <button 
                             onClick={(e) => getAdmitCardsOfAStudent(e,data.semester)} 
                             className="flex text-sm items-center gap-2 bg-orange-600 text-white px-2 py-2 rounded-lg hover:bg-orange-700 transition duration-200"
                           >
                             <AiOutlineDownload size={20} />
                             AdmitCard 
                           </button>
    </div>
  );
};

export default Card;
